import $ from "jquery";
import "jquery-mask-plugin";

function isUsOrCa(countryCode) {
    return countryCode.toUpperCase() === "US" || countryCode.toUpperCase() === "CA";
}

function showIfUsOrCa(element, countryCode) {
    $(element).toggle(isUsOrCa(countryCode));
}

function showIfNotUsOrCa(element, countryCode) {
    $(element).toggle(!isUsOrCa(countryCode));
}

function maskPhone(element, countryCode) {
    if (isUsOrCa(countryCode)) {
        $(element).mask("(000) 000-0000");
    } else {
        unmask(element);
    }
}

function maskZip(element, countryCode) {
    if (countryCode.toUpperCase() === "US") {
        maskZipUs(element);
    } else if (countryCode.toUpperCase() === "CA") {
        maskZipCa(element);
    } else {
        unmask(element);
    }
}

function maskZipCa(element) {
    $(element).mask("abc def", {
        clearIfNotMatch: true,
        translation: {
            "a": {
                pattern: /[A-Za-z]/, optional: false
            },
            "b": {
                pattern: /[0-9]/, optional: false
            },
            "c": {
                pattern: /[A-Za-z]/, optional: false
            },
            "d": {
                pattern: /[0-9]/, optional: false
            },
            "e": {
                pattern: /[A-Za-z]/, optional: false
            },
            "f": {
                pattern: /[0-9]/, optional: false
            }
        },
        onKeyPress: function(value, event) {
            event.currentTarget.value = value.toUpperCase();
        }
    });
}

function maskZipUs(element) {
    $(element).mask("00000");
}

function unmask(element) {
    $(element).unmask();
}

export const addressFormatter = {
    isUsOrCa: isUsOrCa,
    maskPhone: maskPhone,
    maskZip: maskZip,
    showIfUsOrCa: showIfUsOrCa,
    showIfNotUsOrCa: showIfNotUsOrCa,
    unmask: unmask
};